import React, { useEffect, useState } from "react";
import {
    IconRearrange, IconLocked,
    TemplateIconDocument, TemplateIconImage, TemplateIconMultipleChoice, TemplateIconText, TemplateIconVideo, TemplateIconAudio,
    IconActionPencilOutline, IconActionCheck
} from '../../icons/svgs';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Utils from "../Helper/utils";

function SidebarMenuItem({ selectedSlideIndex, index, slide, handleClick, id }) {

    // const [slideName, setSlideName] = useState(slide.name ?? '');
    const [isEditing, setIsEditing] = useState(false);
    const [editedText, setEditedText] = useState(slide.name);

    // console.log(slide);

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: id,
        aaa: 'bbb',
        transition: null
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const templateIcons = {
        document: <TemplateIconDocument />,
        image: <TemplateIconImage />,
        multiplechoice: <TemplateIconMultipleChoice />,
        text: <TemplateIconText />,
        video: <TemplateIconVideo />,
        audio: <TemplateIconAudio />
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleChange = (event) => {
        setEditedText(event.target.value);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSave();
        } else if (event.key === 'Escape') {
            handleCancel();
        }
    };
    const handleSave = () => {
        // setSlideName(editedText);
        if (editedText.length < 4 || editedText.length > 50) {
            Utils.showError('Slide Name minimum 4 and maximum 50');
            return false;
        }
        slide.name = editedText;
        setIsEditing(false);
    };

    const handleCancel = () => {
        setEditedText(slide.name);
        setIsEditing(false);
    };

    useEffect(() => {
        setEditedText(slide.name);
    }, [slide]);

    return (
        <div
            className={`tbcourse-sidebar-items cursor-pointer` + (selectedSlideIndex === index ? ' selected' : '') + (!slide.template.canRearrange() ? ' locked' : '') + (isEditing ? ' edited ' : '')}
            data-id={slide.id}
            // draggable={slide.template.canRearrange() ? true : false}
            ref={setNodeRef}
            style={style}
        >
            <div
                className="tbcourse-sidebar-items-content"
                onClick={() => handleClick(index)}
            >
                {slide.template.canRearrange() ? (
                    <div
                        className="tbcourse-sidebar-items-reorder"
                        {...attributes}
                        {...listeners}
                    >
                        <IconRearrange />
                    </div>
                ) : (
                    <div
                        className="tbcourse-sidebar-items-reorder"
                    >
                        <IconLocked />
                    </div>
                )}
                {/* <div
                    className="tbcourse-sidebar-items-reorder"
                    {...attributes}
                    {...listeners}
                >
                    {slide.template.canRearrange() ? <IconRearrange/> : <IconLocked/>}
                </div> */}
                <span className="tbcourse-sidebar-items-icon">
                    {templateIcons[slide.template.iconType()]}
                </span>
                <div className="tbcourse-sidebar-items-name" title={slide.name}>
                    {/* {slideName} */}
                    {isEditing ? (
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control text-editable"
                                value={editedText}
                                onChange={handleChange}
                                onBlur={handleSave}
                                onKeyDown={handleKeyDown}
                                autoFocus
                            />
                            <div className="input-group-append">
                                <span
                                    className="input-group-text"
                                    onClick={handleSave}
                                >
                                    <IconActionCheck />
                                </span>
                            </div>
                        </div>
                    ) : (
                        slide.name
                    )}
                </div>

                <div className='tbcourse-sidebar-items-actions'>
                    <button type="button" className='' onClick={handleEditClick}>
                        <IconActionPencilOutline />
                    </button>
                </div>

            </div>
        </div>
    );
}

export default SidebarMenuItem;
